const HEADERS = {
  entities: {
    label: 'ENTITIES',
    icon: 'entities',
  },
  dictionaries: {
    label: 'DICTIONARIES',
    icon: 'dictionaries',
  },
  dictionary_entity_entries: {
    label: 'DICTIONARY ENTITY ENTRIES',
    icon: 'entities',
  },
  rule_groups: {
    label: 'CONTEXT RULE GROUPS',
    icon: 'rule-group',
  },
  rules: {
    label: 'CONTEXT RULES',
    icon: 'context-rules',
  },
  intents: {
    label: 'INTENTS',
    icon: 'intents',
  },
  matching_pattern_elements: {
    label: 'MATCHING PATTERNS',
    icon: 'context-rules',
  },
  dictionary_columns: {
    label: 'DICTIONARY COLUMNS',
    icon: 'dictionaries',
  },
  entity_features: {
    label: 'ENTITY FEATURES',
    icon: 'entities',
  },
  constraint_sets: {
    label: 'CONSTRAINT SETS',
    icon: 'intents',
  },
};

export default HEADERS;
